import * as React from "react";
import {ISubmissionProps} from "../utils/models";
import ColdRooms from "./ColdRooms";
import {useEffect, useState} from "react";
import {getSurveySubmissions} from "../utils/submissions";
import Loader from "../../../shared/Loader";

const Energy = ({container, selectedUoa, selectedYear, survey}: ISubmissionProps) => {
    const [loading, setLoading] = useState(true);
    const [submissions, setSubmissions] = useState([]);

    const getSurveysData = async () => {
        setLoading(true)

        if (survey) {
            const data = await getSurveySubmissions({container, survey_id: survey, selectedUoa, selectedYear})
            setSubmissions(data)
        }
    }

    useEffect(() => {
        getSurveysData().then(() => setLoading(false));
    }, [selectedUoa, selectedYear]);

    return (
        <>
            {
                !loading && (
                    <>
                        <div className="content-title col-span-2">
                            Energy sources
                        </div>
                        <div className="space-y-4">
                            <ColdRooms submissions={submissions}/>
                        </div>
                    </>
                )
            }
            {
                loading && (
                    <div className="loader-container col-span-2">
                        <Loader size={60}/>
                    </div>
                )
            }
        </>
    );
}

export default Energy;